import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { company } from "../../data/siteContent";
import { colors } from "../../theme";

const logoSrc = `${process.env.PUBLIC_URL}${company.logos.icon}`;

export default function Loader() {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label="Loading page"
      sx={{
        position: "relative",
        minHeight: { xs: "55vh", md: "60vh" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        py: { xs: 8, md: 10 },
        px: 2,
        bgcolor: colors.slate,
        overflow: "hidden",
      }}
    >
      <LinearProgress
        aria-hidden
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          bgcolor: "primary.light",
          "& .MuiLinearProgress-bar": {
            bgcolor: "primary.main",
          },
        }}
      />

      <Box
        aria-hidden
        sx={{
          position: "absolute",
          top: -80,
          right: -60,
          width: 240,
          height: 240,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(16,163,150,0.12) 0%, transparent 70%)",
        }}
      />
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          bottom: -60,
          left: -40,
          width: 200,
          height: 200,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(242,116,53,0.1) 0%, transparent 70%)",
        }}
      />

      <Box sx={{ position: "relative", width: 96, height: 96 }}>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            border: "3px solid",
            borderColor: "primary.light",
            borderTopColor: "primary.main",
            animation: "loaderSpin 0.9s linear infinite",
            "@keyframes loaderSpin": {
              to: { transform: "rotate(360deg)" },
            },
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 10,
            borderRadius: "50%",
            border: "2px solid transparent",
            borderBottomColor: "secondary.main",
            opacity: 0.85,
            animation: "loaderSpin 1.4s linear infinite reverse",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            animation: "loaderPulse 1.5s ease-in-out infinite",
            "@keyframes loaderPulse": {
              "0%, 100%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" },
              "50%": { opacity: 0.85, transform: "translate(-50%, -50%) scale(0.92)" },
            },
          }}
        >
          <Box
            component="img"
            src={logoSrc}
            alt=""
            sx={{ width: 44, height: 44, objectFit: "contain", display: "block" }}
          />
        </Box>
      </Box>

      <Box sx={{ textAlign: "center", zIndex: 1 }}>
        <Typography variant="subtitle1" fontWeight={700} color="primary.dark">
          {company.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Loading page
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              width: 24,
              ml: 0.5,
              "& span": {
                animation: "loaderDot 1.2s ease-in-out infinite",
                animationFillMode: "both",
              },
              "& span:nth-of-type(1)": { animationDelay: "0s" },
              "& span:nth-of-type(2)": { animationDelay: "0.15s" },
              "& span:nth-of-type(3)": { animationDelay: "0.3s" },
              "@keyframes loaderDot": {
                "0%, 80%, 100%": { opacity: 0.2 },
                "40%": { opacity: 1 },
              },
            }}
          >
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}
